export class ConfirmDataParm{
  public msgConfirm: string;
  public isReturnMsgObs: boolean;
}
